export default "__VITE_ASSET__CjlJdR$I__"